module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "cont"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_c('em', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("Chapter 1: The Five "), _c('em', [_vm._v("C")]), _vm._v("’s of Body Language")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Reading the Whole Body")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The Eyes Have It")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Face to Face")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Talking with Your Hands")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Feet First")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: You’re in My Space")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Power of Touch")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Translating Body Language across Cultures")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Selling Your Message without Saying a Word")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ata#ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cef2874","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0